module.exports = __webpack_public_path__ + "static/media/m-quegudan.b4bd8b41.png";